export enum ActionState {
  PENDING,
  IN_PROGRESS,
  FAILURE,
  SUCCESS,
}
